import { contractRequest } from "./transport";
import type {
  InvitePreview,
  MessageResponse,
  ClinicianAuthResponse,
  ClinicianProfile,
  ClinicianSignupRequest,
} from "./types";

// Public + clinician-token endpoints from the MODULE 1 API CONTRACT. The refresh
// token itself never appears here — like the patient portal, it rides an httpOnly
// cookie the browser handles.

/** 200 { email, expiresAt } · 404 INVITE_INVALID · 410 INVITE_EXPIRED */
export const getClinicianInviteApi = (token: string) =>
  contractRequest<InvitePreview>(`/api/clinician/invitations/${encodeURIComponent(token)}`, { method: "GET" });

/** Unauthenticated, from the invite email's decline link · 404 INVITE_INVALID · 410 INVITE_EXPIRED */
export const declineClinicianInviteApi = (token: string) =>
  contractRequest<MessageResponse>(`/api/clinician/invitations/${encodeURIComponent(token)}/decline`, { method: "POST" });

/**
 * Accepts the invitation with a password and signs the clinician in (same
 * response and refresh cookie as login) — no OTP step. The email comes from
 * the invitation server-side; it is deliberately not sent.
 */
export const clinicianSignupApi = (body: ClinicianSignupRequest) =>
  contractRequest<ClinicianAuthResponse>("/api/clinician/auth/signup", { method: "POST", body });

/** 401 INVALID_CREDENTIALS for wrong password, unknown email, or no CLINICIAN role alike. */
export const clinicianLoginApi = (email: string, password: string) =>
  contractRequest<ClinicianAuthResponse>("/api/clinician/auth/login", { method: "POST", body: { email, password } });

export const clinicianRefreshApi = () =>
  contractRequest<ClinicianAuthResponse>("/api/clinician/auth/refresh", { method: "POST" });

export const clinicianLogoutApi = () =>
  contractRequest<MessageResponse>("/api/clinician/auth/logout", { method: "POST", portal: "clinician" });

export const getClinicianMeApi = () =>
  contractRequest<ClinicianProfile>("/api/clinician/me", { method: "GET", portal: "clinician" });
